import { TokenGestaoEmpresaPerfilModel } from "./token-gestao-empresa-perfil-model";

export enum TokenGestaoEmpresaTipoEnum {
    Operador = 0,
    Cliente = 1,
}

export class TokenGestaoEmpresaModel {
    constructor(
        public Id: string = "",
        public ContratoId: string = "",
        public Documento: string = "",
        public Descricao: string = "",
        public Perfil: TokenGestaoEmpresaPerfilModel = new TokenGestaoEmpresaPerfilModel(),
    ) { }
}